import requests from '../../api/client'
import { OtpApiResult, ResendOtpOk, OtpError, HttpAnswer } from '../../types/otp'
import extractOtpMessage from './extractOtpMessage'

interface ResendOtpParams {
  otp_session_token: string
}

export default async function resendOtp(
  params: ResendOtpParams
): Promise<OtpApiResult<ResendOtpOk>> {
  const response = (await requests.otpResend(params)) as HttpAnswer
  const status = response?.status ?? 200
  const data = response?.data ?? response

  if (status >= 200 && status < 300) {
    return { status, body: data as ResendOtpOk }
  }

  const body: OtpError = {
    retorno: false,
    message: extractOtpMessage(data, 'Não foi possível reenviar o código.'),
  }
  return { status, body }
}